import { Segment } from "semantic-ui-react";
import ComingSoonPlaceholder from '../../Assessment/ComingSoonPlaceholder'
import styles from "./DomainTasks.module.css"
import header from "../../Assessment/AssessmentInfoSlideControls/DomainTaskTitleComponent.module.css"
// import { DomainTaskTitle } from "./DomainTaskTitleComponent";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";


export const MedicalDomainTask1 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  
  return {
    header: "Geriatric Assessment",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}MedicalModuleGeriatric.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  A comprehensive geriatric assessment is an evaluation to
                  determine the functional capabilities of an older adult in order
                  to develop a plan for care during the aging process. This tool
                  can improve healthcare outcomes for the older adult and can be
                  beneficial to you when helping to manage their care.
                </p>
                <p >
                  This assessment can help to ensure their concerns are accurately
                  diagnosed and they receive the most effective treatments and
                  preventive healthcare possible. If the older adult has a
                  geriatric physician, you can schedule it with them. If not,
                  their primary care provider should be able to complete this
                  assessment as well.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>

      </>
    ),
  };
};

export const MedicalDomainTask2 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Monitoring Changes",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic style={{ display: "flex" }} >
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  A good relationship with the physician can be
                  helpful as you attempt to understand your loved one's medical conditions
                  and monitor changes that should be brought to the physician's
                  attention. The people who spend the most time around the older
                  adult will likely be the ones to notice these changes first.
                </p>
                <p >
                  It is also important to determine the functional status of the older adult which evaluates
                  their capacity for independent living and will determine aspects of care. Functional
                  status can range from fully independent to needing assistance to fully dependent on
                  others. By monitoring changes in the older adult's functional status, you can ensure they
                  are receiving care based on their changing needs.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer} style={{ width: "100%" }}>{questionCompleter}</div>
            </div>
            <div style={{ float: "right" }}>
              <video controls preload="auto" poster={`${cdnRoute}DadPlaceholder.jpg`} width="600" height="337">
                <source src={`${cdnRoute}dad-movie-clip-edited.mp4`} type="video/mp4"></source>
              </video>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask3 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Healthcare Team",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}DrivingPlaceholder.jpg)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Becoming an active member of the older adult's healthcare team
                  can be very beneficial when it comes to maintaining their
                  health. Along with their physicians and other healthcare
                  professionals, you can play an active role in making the best
                  use of medical advice and treatment. If the older adult doesn't
                  have a good primary care physician, it is essential to help them
                  find one. The right healthcare team can make all the difference.
                </p>
                <p >
                  This process can work best when the older adult is also an
                  active member of the team. By educating themselves on health
                  condition and monitoring their health and symptoms, they can
                  share this information with their physicians and work together
                  to figure out best practices to reach their healthcare goals.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask4 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Medication Management",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}MedicalManagementSlide.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Older adults frequently take multiple medicines, some prescribed
                  by their physician and others purchased over the counter.
                  Keeping track of medication can become confusing for the older
                  adult and caregivers, especially when new ones are added, or
                  dosages are adjusted. Changes in functional status can also
                  increase the likelihood of medication-related issues.
                </p>
                <p >
                  One way to stay organized is to create a medication list. It is
                  helpful to include the name of each medication, what condition
                  the medication is used to treat, how much to take, when to take
                  it, and which doctor prescribed it. Give a copy to each of the
                  older adult's caregivers and be sure to keep it updated.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask5 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Evaluate Driving Skills",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} `}
            style={{ backgroundImage: `url(${cdnRoute}EvaluateDrivingSkills.png)` }}>
            <div className={`${styles.domainTaskContent} `}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  One of the most difficult issues older adults and family members face is whether the older adult
                  can safely continue to drive an automobile. Often the older adult and family members have differing
                  views of the older adult's driving skills, reaction time, ability to see and hear, or judgment.
                </p>
                <p >
                  This issue is best confronted long before any question arises about the older adult's safety. By
                  discussing the issue in advance of concerns, the older adult and family members can establish criteria
                  (i.e., results of an objective driving skills evaluation or physician's recommendation) for limiting
                  night driving or ceasing driving completely. Such plans should include concrete transportation
                  alternatives, so that the older adult's independence and freedom of choice is not compromised.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask6 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Plan with Geriatric Care Manager",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={styles.imgGradientHorizontal}
            style={{ backgroundImage: `url(${cdnRoute}Medical_PlanWithGeriatricCareManager.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Geriatric care managers are experts in planning and organizing a variety of services to meet the changing
                  needs of older adults. Typically, they meet with older adults and family members to assess needs and discuss
                  concerns that may arise (e.g., memory loss, functional impairment, difficult with transportation, household tasks).
                </p>
                <p >
                  Following such an assessment, they create a plan of care. The plan includes recommendations about services to help
                  the older adult remain at home safely or to a more appropriate living situation. Geriatric care managers provide
                  a kind of “one-stop shop” to help older adults and their families access services and resources to promote
                  successful aging. They work with families over time and reassess needs and services as circumstances change.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask7 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Assess Facility Quality",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`}
            style={{ backgroundImage: `url(${cdnRoute}Medical_AssessFacilityQuality.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  At some point in the future, it may be necessary for your parent to live in a retirement community, assisted
                  living residence, or other similar setting. It is important to become knowledgeable about the various choices
                  in your parent's home community and how your parent and others you trust (friends, clergy, health care
                  professionals, family) view these residences.
                </p>
                <p >
                  Most such facilities are quite eager to take prospective residents and their family members for a tour, even
                  years in advance of anticipated need, and will be happy to answer questions about services, costs, policies,
                  and other matters. Knowing in advance of need which residences are most and least appropriate for your parent
                  will help aid in decision making, should your parent need such a facility for a short- or long-term stay.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask8 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Exercise and Activity Plan",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`}
            style={{ backgroundImage: `url(${cdnRoute}Medical_ExerciseAndActivityPlan.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Regular physical activity is one of the most important things the older adult can do for their health. It can help
                  to prevent or delay many common issues that come along with aging. Keeping their muscles strong can also help to
                  keep them independent for longer. Fitness and yoga classes can also be a great social opportunity as well.
                </p>
                <p >
                  Aerobic activities like walking, muscle-toning activities like using light weights, and balance activities like
                  standing on one leg or yoga can do wonders for older adults. Be sure to discuss this with their physician before
                  starting any type of exercise plan.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask9 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Learn about Cognitive Impairment",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={styles.imgGradientHorizontal}
            style={{ backgroundImage: `url(${cdnRoute}Medical_LearnAboutCognitiveImpairment.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is this Task & Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Cognitive impairment is when a person has trouble remembering, learning new things, concentrating, or making
                  decisions. The level of impairment can range from mild to severe and can change quickly. It is not caused by
                  one specific disease or condition and is not limited to specific age ranges.
                </p>
                <p >
                  It is important to keep track of any warning signs you or others may notice as cognitive impairment can
                  drastically affect the care the older adult may need. Things like asking the same questions repeatedly,
                  becoming lost in familiar places, losing things, getting confused often, and changes in mood and behavior can
                  all be signs of cognitive impairment. If you notice any of these behaviors, consult the older adult's physician
                  as soon as possible.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTaskPlaceholder = () => {
  return {
    header: "Task Coming Soon",
    content: (
      <ComingSoonPlaceholder />
    ),
  };
};